import { createAppAsyncThunk } from 'src/store/utils/thunks';

import { wsMmSend, createMmWsAction } from '@skynet/data-ws-mm';
import { RetainerCommands } from './types';

export interface ListenPayload {
  section: string; // 'balances' or 'overview';
  projectID?: number;
}

export interface HideProjectPayload {
  projectID?: number;
}

export const listen = createMmWsAction<ListenPayload, ListenPayload>(
  'retainers/listen',
  (data) => ({
    command: 'Listen',
    ...data,
  }),
);

export const hideProject = createAppAsyncThunk(
  'retainers/hideProject',
  (data: HideProjectPayload, thunkApi) => {
    thunkApi.dispatch(
      wsMmSend({
        command: RetainerCommands.HideRetainer,
        ...data,
      }),
    );
  },
);
